import { useAuth } from '../contexts/AuthContext';

/**
 * Returns the analyst quota from the already-fetched user object in AuthContext.
 * Source: GET /api/accounts/me/ → quota.analyst
 *
 * Returns:
 *   quota  — { used_today, daily_limit, used_month, monthly_limit }, or null
 *            null means: unauthenticated or unlimited plan (daily_limit === null)
 */
export default function useDetailViewQuota() {
  const { user } = useAuth();

  const analyst = user?.quota?.analyst ?? null;
  const quota = analyst?.daily_limit === null ? null : analyst;

  return { quota };
}
